<template>
  <div class="main">
    <div class="welcome">珠宝鉴赏平台，欢迎您</div>
    <div class="title">
      <img src="../../assets/appreciateTitle.png" alt="" />
    </div>
    <div class="box">
      <div class="phone">
        <img src="../../assets/appreciatePhone.png" alt="" />

        <input
          type="number"
          placeholder="请输入手机号"
          v-model="phoneNumber"
          max="11"
          oninput="if(value.length>11)value=value.slice(0,11)"
        />
      </div>
      <div class="line"></div>
      <div class="code">
        <img src="../../assets/appreciateCode.png" alt="" />

        <input
          type="text"
          placeholder="请输入验证码"
          v-model="code"
          oninput="if(value.length>6)value=value.slice(0,6)"
        />

        <div class="getCode" @click="getCode">获取验证码</div>
      </div>
    </div>
    <div class="agreement">
      <van-checkbox v-model="checked" icon-size="8px">
        <span style="color: rgba(255, 255, 255, 0.8)"
          >请阅读并同意
          <span @click="toAgreement">《珠宝鉴赏服务协议》</span></span
        >
      </van-checkbox>
    </div>
    <div class="btns">
      <div class="register" @click="toRegister"></div>
      <div class="login" @click="toLogin"></div>
    </div>
    <div class="otherLogin">
      <div>一键登录</div>
      <img src="../../assets/wxLogin.png" alt="" @click="loginByWX" />
      <img src="../../assets/dyLogin.png" alt="" @click="loginByDY" />
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GmcsWebH5Login",

  data() {
    return {
      phoneNumber: "",
      code: "",
      checked: false,
    };
  },

  mounted() {},

  methods: {
    handlePhoneChange(val) {
      console.log(val);
    },
    getCode() {
      if (this.phoneNumber.length !== 11) {
        this.$toast("即将开放，敬请期待");
      } else {
        console.log(11);
      }
    },
    loginByWX() {
      this.$toast("即将开放，敬请期待");
    },
    loginByDY() {
      this.$toast("即将开放，敬请期待");
    },
    toLogin() {
      this.$toast("即将开放，敬请期待");
    },
    toRegister() {
      this.$toast("即将开放，敬请期待");
    },
    toAgreement() {
      this.$router.push({
        path: "/appreciate/agreement",
      });
    },
  },
};
</script>

<style lang="less" scoped>
::v-deep .van-checkbox__label {
  font-size: 22px;
  color: #ffffff;
  margin-top: 6px;
}
::v-deep .van-icon {
  width: 24px;
  height: 24px;
  line-height: 24px;
}
input::-webkit-input-placeholder {
  /* WebKit browsers，webkit内核浏览器 */
  color: rgba(255, 255, 255, 0.8);
  font-size: 28px;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: rgba(255, 255, 255, 0.8);
  font-size: 28px;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: rgba(255, 255, 255, 0.8);
  font-size: 28px;
}
.main {
  background: url("../../assets/appreciateLoginBackground.png") no-repeat;
  height: 100vh;
  background-size: 100% 100%;
  overflow: hidden;
  padding: 32px;
  box-sizing: border-box;
  .welcome {
    font-size: 24px;
    height: 33px;
    color: #ffffff;
  }
  .title {
    margin: 0 auto;
    margin-top: 116px;
    width: 352px;
    height: 97px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .otherLogin {
    width: 384px;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    margin-top: 136px;
    > div {
      font-size: 24px;
      color: rgba(255, 255, 255, 0.8);
    }
    > img {
      width: 48px;
      height: 48px;
    }
    .line {
      width: 96px;
      height: 1px;
      background: rgba(255, 255, 255, 0.8);
    }
  }
  .btns {
    width: 510px;
    height: 68px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 64px;
    .register {
      width: 239px;
      height: 68px;
      background: url("../../assets/appreciateRegister.png") no-repeat;
      background-size: 100% 100%;
    }
    .login {
      width: 239px;
      height: 68px;
      background: url("../../assets/appreciateLogin.png") no-repeat;
      background-size: 100% 100%;
    }
  }
  .agreement {
    margin-left: 114px;
    margin-top: 12px;
  }
  .box {
    width: 509px;
    height: 192px;
    background: #ffffff;
    border-radius: 16px 16px 16px 16px;
    opacity: 1;
    margin: 0 auto;
    margin-top: 120px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    justify-content: space-between;
    background-image: linear-gradient(
      to left,
      rgb(213, 57, 61),
      rgb(233, 71, 69)
    );
    filter: blur(0.5);
    padding: 32px 25px;
    input {
      border: none;
      height: 40px;
      background-color: transparent;
      line-height: 40px;
      color: #ffffff;
      width: 240px;
    }
    img {
      width: 40px;
      height: 40px;
      margin-right: 24px;
    }
    .phone {
      display: flex;
      height: 40px;
      font-size: 28px;
      line-height: 40px;
      .getCode {
        font-size: 24px;
        color: #ffffff;
        width: 120px;
      }
    }
    .code {
      display: flex;
      height: 40px;
      font-size: 28px;
      line-height: 40px;
      align-items: center;

      .getCode {
        font-size: 24px;
        color: rgba(255, 255, 255, 0.8);
        width: 150px;
        height: 33px;
        line-height: 33px;
        text-align: right;
      }
    }
    .line {
      height: 1px;
      width: 100%;
      background-color: #ffffff;
    }
  }
}
</style>
